import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { DollarSign, AlertCircle } from 'lucide-react';

interface ApplyLeadConfirmationProps {
  leadId: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ApplyLeadConfirmation({ leadId, onConfirm, onCancel }: ApplyLeadConfirmationProps) {
  return (
    <AlertDialog open={true} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent className="lead-confirm-dialog max-w-md tailwind-prefix">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-amber-100 rounded-full">
              <AlertCircle className="size-6 text-amber-600" />
            </div>
            <AlertDialogTitle className="text-left">Platform Fee Notice</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-left space-y-3">
            <p className="text-gray-700">
              The Tradesmen's Collective will charge a platform fee if this lead is successful.
            </p>
            <p className="text-gray-700">
              Do you want to continue and apply for this lead?
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>No, Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800"
          >
            Yes, Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
